/**
 * FE-C2e: Groups hub directory — contract paths for summary + NGS fallback.
 */

import { buildContractPath } from "./api/contract-client.js";

/** Matches `group_shares/hub_summary.py` service cap. */
export const NGS_SHARES_FALLBACK_LIMIT = 2000;

/**
 * @param {string | null | undefined} ownerScope
 * @returns {string}
 */
export function buildGroupsHubSummaryPath(ownerScope) {
  const scope = ownerScope != null ? String(ownerScope).trim() : "";
  const query = scope ? { owner_scope: scope } : {};
  return buildContractPath("get__admin_groups-hub_summary", { query });
}

/**
 * @param {string | null | undefined} ownerScope
 * @returns {string}
 */
export function buildNotificationGroupSharesFallbackPath(ownerScope) {
  const query = { limit: NGS_SHARES_FALLBACK_LIMIT };
  const scope = ownerScope != null ? String(ownerScope).trim() : "";
  if (scope) query.owner_scope = scope;
  return buildContractPath("get__admin_notification-groups_shares", { query });
}
